export const getTeaserColumns = (type) => {
    if (type) {
        switch (type) {
            case 'block':
            case 'row':
            case 'col':
            case 'rows':
                return 1;
            default:
                return 2;
        }
    }
    return 2;
};
export const getTeaserCellRows = (type, index) => {
    if (type) {
        switch (type) {
            case 'block':
            case 'row':
            case 'col':
            case 'rows':
                return 1;
            case 'blocks':
            case 'cols':
                return 2;
            case 'row-cols':
                if (index === 0) {
                    return 2;
                }
                return 1;
            case 'cols-row':
                if (index === 2) {
                    return 2;
                }
                return 1;
            case 'rows-col':
                if (index === 1) {
                    return 2;
                }
                return 1;
            case 'col-rows':
                if (index === 0) {
                    return 2;
                }
                return 1;
            default:
                return 2;
        }
    }
    return 1;
};
export const getTeaserCellColumns = (type, index) => {
    if (type) {
        switch (type) {
            case 'block':
            case 'row':
            case 'col':
            case 'cols':
            case 'rows-col':
                return 1;
            case 'blocks':
            case 'rows':
                return 2;
            case 'col-rows':
                return 1;
            case 'row-cols':
                if (index === 0) {
                    return 2;
                }
                return 1;
            case 'cols-row':
                if (index === 2) {
                    return 2;
                }
                return 1;
            default:
                return 2;
        }
    }
    return 1;
};
